export default function AboutMe() {
  return (
    <section id="AboutMe" className="about-section">
      <div className="about-section-img">
        <span className="decor-dot dd1" aria-hidden="true"></span>
        <span className="decor-dot dd2" aria-hidden="true"></span>
        <span className="decor-dot dd3" aria-hidden="true"></span>
        <img src="/primary-logo.png" alt="Tech With Manny logo" />
      </div>
      <div className="hero-section-content-box-about-section-box">
        <div className="hero-section-content about-card">
          {/* <p className="section-title">About</p> */}
          <h1 className="skills-section-heading about-heading">About Me</h1>
          <p className="hero-section-description about-text">
            Cloud-DevOps Engineer with 5+ years of experience designing, deploying, and optimising cloud-native solutions across multi-environment AWS infrastructures.
          </p>
          <p className="hero-section-description about-text">
            Proven track record in implementing robust CI/CD pipelines, automating infrastructure provisioning, and managing containerised applications at scale. Strong expertise in Infrastructure as Code, container orchestration, and performance optimisation, with 21 professional certifications including 8 AWS certifications and Terraform certification.
          </p>
          <p className="hero-section-description about-text">
            Demonstrated ability to collaborate effectively with development teams whilst driving automation initiatives that reduce operational overhead and enhance system reliability.
          </p>
        </div>
      </div>
    </section>
  );
}
